module.exports = __webpack_public_path__ + "img/V70.40a37728.jpg";